export default __webpack_public_path__ + "static/media/about-us-commercial.0a7af635.jpg";